// extracted by mini-css-extract-plugin
export default {"UserTag":"styles_UserTag__GHfgJ","remove":"styles_remove__eajwP"};